interface ValidationRule {
  latestSelection: string;
  itemsToBeEnabled: string[];
  itemsToBeDisabled: string[];
}

export const customGroupsvalidationRules: ValidationRule[] = [
  {
    latestSelection: 'METRIC',
    itemsToBeEnabled: [')', 'AND', 'OR', '+', '-', '*', '/'],
    itemsToBeDisabled: ['(', 'NOT', 'METRIC', 'NUMERAL'],
  },
  {
    latestSelection: '(',
    itemsToBeEnabled: ['(', 'NOT', 'METRIC'],
    itemsToBeDisabled: [')', 'AND', 'OR', '+', '-', '*', '/', 'NUMERAL'],
  },
  {
    latestSelection: ')',
    itemsToBeEnabled: [')', 'AND', 'OR', '+', '-', '*', '/'],
    itemsToBeDisabled: ['(', 'NOT', 'METRIC', 'NUMERAL'],
  },
  {
    latestSelection: 'AND',
    itemsToBeEnabled: ['(', 'NOT', 'METRIC'],
    itemsToBeDisabled: [')', 'AND', 'OR', '+', '-', '*', '/', 'NUMERAL'],
  },
  {
    latestSelection: 'OR',
    itemsToBeEnabled: ['(', 'NOT', 'METRIC'],
    itemsToBeDisabled: [')', 'AND', 'OR', '+', '-', '*', '/', 'NUMERAL'],
  },
  {
    latestSelection: 'NOT',
    itemsToBeEnabled: ['(', 'METRIC'],
    itemsToBeDisabled: [')', 'AND', 'OR', 'NOT', '+', '-', '*', '/', 'NUMERAL'],
  },
  {
    latestSelection: '+',
    itemsToBeEnabled: ['(', 'NUMERAL', 'METRIC'],
    itemsToBeDisabled: [')', '-', '*', '/', '+', 'NOT', 'AND', 'OR'],
  },
  {
    latestSelection: '-',
    itemsToBeEnabled: ['(', 'NUMERAL', 'METRIC'],
    itemsToBeDisabled: [')', '+', '*', '/', '-', 'NOT', 'AND', 'OR'],
  },
  {
    latestSelection: '*',
    itemsToBeEnabled: ['(', 'NUMERAL', 'METRIC'],
    itemsToBeDisabled: [')', '-', '+', '/', '*', 'NOT', 'AND', 'OR'],
  },
  {
    latestSelection: '/',
    itemsToBeEnabled: ['(', 'NUMERAL', 'METRIC'],
    itemsToBeDisabled: [')', '+', '*', '-', '/', 'NOT', 'AND', 'OR'],
  },
  {
    latestSelection: 'NUMERAL',
    itemsToBeEnabled: [')', '+', '-', '*', '/'],
    itemsToBeDisabled: ['(', 'METRIC', 'NUMERAL', 'NOT', 'AND', 'OR'],
  },
];

export const customCalculationvalidationRules: ValidationRule[] = [
  {
    latestSelection: 'METRIC',
    itemsToBeEnabled: [')', '+', '-', '*', '/'],
    itemsToBeDisabled: ['(', 'NUMERAL'],
  },
  {
    latestSelection: '(',
    itemsToBeEnabled: ['(', 'NUMERAL', 'METRIC'],
    itemsToBeDisabled: [')', '+', '-', '*', '/'],
  },
  {
    latestSelection: ')',
    itemsToBeEnabled: [')', '+', '-', '*', '/'],
    itemsToBeDisabled: ['(', 'NUMERAL', 'METRIC'],
  },
  {
    latestSelection: '+',
    itemsToBeEnabled: ['(', 'NUMERAL', 'METRIC'],
    itemsToBeDisabled: [')', '-', '*', '/', '+'],
  },
  {
    latestSelection: '-',
    itemsToBeEnabled: ['(', 'NUMERAL', 'METRIC'],
    itemsToBeDisabled: [')', '+', '*', '/', '-'],
  },
  {
    latestSelection: '*',
    itemsToBeEnabled: ['(', 'NUMERAL', 'METRIC'],
    itemsToBeDisabled: [')', '-', '+', '/', '*'],
  },
  {
    latestSelection: '/',
    itemsToBeEnabled: [ 'NUMERAL'],
    itemsToBeDisabled: ['(',')', '+', '*', '-','/','METRIC', '/'],
  },
  {
    latestSelection: 'NUMERAL',
    itemsToBeEnabled: [')', '+', '-', '*', '/'],
    itemsToBeDisabled: ['(', 'METRIC', 'NUMERAL'],
  },
];
